/* AUTOGENERATED FILE - DO NOT EDIT CONTENTS */

export const projectId = "dgyfsgrevborjtzcafge"
export const publicAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRneWZzZ3JldmJvcmp0emNhZmdlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjM1ODYwMTYsImV4cCI6MjA3OTE2MjAxNn0.qhsEb_v5kYdZ-inBHd7OjpoPYF8NeVxIGWLb7VYc6CQ"